import { Paper, Typography } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import {
  StandardRowContainer,
  StretchRow,
} from "components/Layout/StandardStyledComponents";
import { useStyles } from "Theme/styles";

interface ItemCardProps {
  title: string;
}

export default function ItemCard({ title }: ItemCardProps) {
  const classes = useStyles();

  return (
    <Paper className={classes.paperCard}>
      <StandardRowContainer>
        <StretchRow>
          <Typography>{title}</Typography>
        </StretchRow>
        <Edit />
        <Delete />
      </StandardRowContainer>
    </Paper>
  );
}
